var map = {
	"./AboutUsPage.vue": 923,
	"./ArticlePage.vue": 890,
	"./CampaignPage.vue": 924,
	"./CareerPage.vue": 925,
	"./CaseStudyPage.vue": 926,
	"./ContactUsPage.vue": 927,
	"./CustomCampaignPage.vue": 928,
	"./EbookPage.vue": 891,
	"./EventPage.vue": 886,
	"./ExternalContentPage.vue": 929,
	"./GatedContentPage.vue": 86,
	"./InvestorRelations/IRAgmPage.vue": 930,
	"./InvestorRelations/IRContactUsPage.vue": 931,
	"./InvestorRelations/IRCorporateGovernancePage.vue": 932,
	"./InvestorRelations/IRDebtInvestorsPage.vue": 933,
	"./InvestorRelations/IREquityProspectusPage.vue": 934,
	"./InvestorRelations/IRGroupFactsAndFiguresPage.vue": 935,
	"./InvestorRelations/IRPeoplePage.vue": 936,
	"./InvestorRelations/IRReportsAndPresentationsPage.vue": 937,
	"./InvestorRelations/IRShareInformationPage.vue": 883,
	"./NotFound404Page.vue": 938,
	"./OurPlatformPage.vue": 939,
	"./PageListPage.vue": 887,
	"./PeoplePage.vue": 940,
	"./PracticeAreaPage.vue": 888,
	"./ProductPage.vue": 941,
	"./SearchPage.vue": 942,
	"./ServiceListPage.vue": 943,
	"./ServicePage.vue": 944,
	"./SoftwarePartnerPage.vue": 945,
	"./SoftwarePartnersOverviewPage.vue": 889,
	"./StartPage.vue": 885,
	"./VacancyPage.vue": 946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806;